import {createSelector} from 'reselect';

import {buildApiTokenScopeFromTeam, defaultApiTokenScopes} from '../../../helpers/apiTokenHelpers';
import {AppParametricSelector} from '../../../helpers/reselectHelpers';
import {getApiTokens} from '../dataSelectors';
import {getFlatTeams} from '../teams/teamsSelectors';

/*
 * Selectors.
 */

export function makeGetApiToken(getTokenId: AppParametricSelector<any, number | undefined>) {
  return createSelector([getTokenId, getApiTokens], (tokenId, apiTokens) => {
    if (!tokenId) {
      return undefined;
    }
    return apiTokens[tokenId];
  });
}

export const getApiTokenScopes = createSelector(getFlatTeams, (teams) => [
  ...defaultApiTokenScopes,
  ...[...teams].map((team) => buildApiTokenScopeFromTeam(team)),
]);
